import { PromoAnalyticsService } from '@analytics/feature';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BannerGridItem } from '@promo/const';
import { PromoService } from '@promo/data-access';
import { InViewportDirective, SdvorGenericLinkComponent } from '@sdvor/shared/ui';
import { DeviceService } from '@shared/services';
import { combineLatest, filter, map, Observable } from 'rxjs';

@Component({
  selector: 'sd-banner-grid',
  imports: [AsyncPipe, NgOptimizedImage, SdvorGenericLinkComponent, InViewportDirective],
  templateUrl: './banner-grid.component.html',
  styleUrls: ['./banner-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerGridComponent implements OnInit {
  isTablet$: Observable<boolean> = this.deviceService.isTabletMdUp$;
  isDesktop$: Observable<boolean> = this.deviceService.isDesktopLgUp$;
  isLoading$: Observable<boolean> = this.promoService.getPromoLoading();

  bannersGrid$: Observable<BannerGridItem[]>;

  constructor(
    public deviceService: DeviceService,
    private promoService: PromoService,
    private promoAnalyticsService: PromoAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.bannersGrid$ = combineLatest({
      promo: this.promoService.getPromo().pipe(filter((promo) => !!promo)),
      isTablet: this.isTablet$,
      isDesktop: this.isDesktop$,
    }).pipe(
      map(({ promo, isTablet, isDesktop }) => {
        if (promo?.bannersGrid) {
          return promo.bannersGrid.map((banner) => {
            const { url } = banner;

            return {
              ...banner,
              url: isDesktop ? url.isDesktop : isTablet ? url.isTablet : url.isMobile,
            };
          });
        }

        return [];
      }),
    );
  }

  protected onBannerClick(banner: BannerGridItem): void {
    const { id, name } = banner;

    this.promoAnalyticsService.onClickBanner({
      id,
      name: name,
      position: 'main_page',
    });
  }

  protected onBannerIntersect(banner: BannerGridItem): void {
    const { id, name } = banner;

    this.promoAnalyticsService.onShowBanner({
      id,
      name,
      position: 'main_page',
    });
  }
}
